<template>
  <div class="singleChart col-12 row text-center mx-0 mb-0 px-0">
    <template v-if="singleChartOptions.length <= 1">
      <div class="col-12">
        <chart
          :chartId="singleChartDetail.chartId"
          :chartName="singleChartDetail.chartName"
          :styleGroup="singleChartDetail.styleGroup"
          :chartData="singleChartSelected.data"
        ></chart>
      </div>
    </template>
    <template v-else>
      <div class="col-10">
        <chart
          :chartId="singleChartDetail.chartId"
          :chartName="singleChartDetail.chartName"
          :styleGroup="singleChartDetail.styleGroup"
          :chartData="singleChartSelected.data"
        ></chart>
      </div>
      <div class="col-2">
        <b-form-group>
          <b-form-radio-group
            v-model="selected"
            :options="singleChartOptions"
            name="radios-stacked"
            stacked
            class="my-5 text-left"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import chart from "@/components/chart.vue";
export default {
  name: "singleChart",
  data() {
    return {
      selected: {},
      options: [],
    };
  },
  mounted: function () {
    let vm = this;
    if (vm.singleChartOptions.options != null) {
      vm.selected = vm.singleChartOptions.options[0].value;
    }
  },
  components: {
    chart,
  },
  watch: {
    singleChartSelected: {
      handler() {
        let vm = this;
        vm.selected = vm.singleChartSelected;
      },
      deep: true,
    },
    selected: {
      handler() {
        let vm = this;
        vm.set_singleChartSelected(vm.selected);
      },
    },
  },
  computed: {
    ...mapGetters({
      singleChartSelected: "singleChart/get_singleChartSelected",
      singleChartOptions: "singleChart/get_singleChartOptions",
      singleChartDetail: "singleChart/get_singleChartDetail",
    }),
  },
  methods: {
    ...mapActions({
      set_singleChartSelected: "singleChart/set_singleChartSelected",
    }),
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/singleChart.vue